import {
	RDX_APP_API_START, RDX_APP_API_END, RDX_APP_MODULE_START, RDX_APP_MODULE_END, RDX_APP_API_INIT,
	RDX_APP_PRE_LOGON, RDX_APP_LOGOUT,
	RDX_APP_SESSIONTIMEOUT_OPEN, RDX_APP_SESSIONTIMEOUT_RESET,
	OPEN_OVERLAY,
	CLOSE_OVERLAY,
	RDX_APP_LOGON
} from './appAction';

const initial = {
	apiInflight: 0,
	moduleLoaded: false,
	logonState: '',
	timeoutResetTime: undefined,
	overlayList: []
};

const app = (state = initial, action) => {
	let newState = { ...state };
	switch (action.type) {
		case RDX_APP_API_INIT:
			newState.apiInflight = 0;
			return newState;
		case RDX_APP_API_START:
			newState.apiInflight++;
			return newState;
		case RDX_APP_API_END:
			newState.apiInflight--;
			if (newState.apiInflight < 0) {
				newState.apiInflight = 0;
			}
			return newState;
		case RDX_APP_MODULE_START:
			newState.moduleLoaded = false;
			return newState;
		case RDX_APP_MODULE_END:
			newState.moduleLoaded = true;
			return newState;
		case RDX_APP_LOGON :
			newState.logonState = action.logonState;
			return newState;

		case RDX_APP_PRE_LOGON:
			newState.logonState = action.logonState;
			newState.overlayList = [];
			return newState;
		case RDX_APP_LOGOUT:
			return state;
		case RDX_APP_SESSIONTIMEOUT_OPEN:
			return { ...newState, timeoutResetTime: 0 };
		case RDX_APP_SESSIONTIMEOUT_RESET:
			return { ...newState, timeoutResetTime: (new Date()).getTime() };
		case OPEN_OVERLAY:
			newState.overlayList.push(action.overlayId);
			return { ...state, overlayList: newState.overlayList };
		case CLOSE_OVERLAY:
			newState.overlayList.shift();
			return { ...state, overlayList: newState.overlayList };
		default:
			return state;
	}
};

export default app;